import React from "react";
import { Link } from "react-router-dom";
import PageSEO from "../../SEO/PageSEO";
import "./Leadership.css";
import leadershipImg from "../../../images/photo_5976566633449243957_y.jpg";
import joelImg from "../../../images/joel mirembe.jpeg";
import joel1 from "../../../images/leadership-board-yitalife.jpeg";

/* SVG placeholder rendered inline; initials shown inside a styled circle */
function AvatarPlaceholder({ initials, color = "#112898" }) {
  return (
    <div className="leader-placeholder" aria-hidden="true">
      <svg
        viewBox="0 0 120 120"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
      >
        {/* Background circle */}
        <circle cx="60" cy="60" r="60" fill={color} opacity="0.12" />
        {/* Torso silhouette */}
        <circle cx="60" cy="44" r="18" fill={color} opacity="0.35" />
        <ellipse cx="60" cy="90" rx="28" ry="20" fill={color} opacity="0.25" />
        {/* Initials */}
        <text
          x="60"
          y="50"
          textAnchor="middle"
          dominantBaseline="middle"
          fill={color}
          fontFamily="Montserrat, sans-serif"
          fontWeight="800"
          fontSize="22"
        >
          {initials}
        </text>
      </svg>
    </div>
  );
}

const leadership = [
  {
    name: "Dr. Joel Mirembe",
    role: "Managing Director",
    qualifications: "MBChB, MSc.",
    bio: "Dr. Mirembe is the managing director of Yita Medical Services.",
    img: joelImg,
    initials: "JM",
    social: { twitter: "https://x.com/yitalife" },
    accentColor: "#112898",
  },
  {
    name: "Medical Director",
    role: "Clinical Lead",
    qualifications: "MBChB; Clinical Medicine",
    bio: "Our Medical Director oversees the clinical standards, protocols, and quality of care delivered by all Yitalife healthcare professionals. All patient care protocols are reviewed and approved by the clinical team.",
    img: null,
    initials: "MD",
    social: {},
    accentColor: "#1bbc9b",
  },
  {
    name: "Head of Operations",
    role: "Operations & Logistics",
    qualifications: "Health Systems Management",
    bio: "The Head of Operations ensures that Yitalife's services are delivered efficiently, safely, and on time; coordinating our network of doctors, nurses, and logistics across Kampala and Uganda.",
    img: null,
    initials: "HO",
    social: {},
    accentColor: "#e42326",
  },
  {
    name: "Community Outreach Lead",
    role: "Community Health & Partnerships",
    qualifications: "Public Health; Community Development",
    bio: "Leads Yitalife's community outreach programmes, corporate partnerships, and health advocacy campaigns; ensuring our services reach the people who need them most.",
    img: null,
    initials: "CO",
    social: {},
    accentColor: "#f59e0b",
  },
];

const boardStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Yitalife Leadership - Yita Medical Services",
  description:
    "Meet the leadership team and board of Yitalife - a service of Yita Medical Services (YMS). Uganda's trusted home healthcare organisation.",
  url: "https://www.yitalife.com/Leadership",
};

export default function Leadership() {
  return (
    <div>
      <PageSEO
        title="Our Leadership Team - Yitalife, Yita Medical Services"
        description="Meet the founders, clinical leads, and leadership team behind Yitalife - a service of Yita Medical Services (YMS). Building trusted, professional home healthcare in Uganda since 2017."
        canonical="https://www.yitalife.com/Leadership"
        ogImage="https://www.yitalife.com/logo.png"
        structuredData={boardStructuredData}
      />

      {/* Hero */}
      <div
        className="page-hero"
        style={{ backgroundImage: `url(${leadershipImg})` }}
      >
        <div className="container page-hero-content">
          <h1 data-aos="fade-down">Our Leadership</h1>
          <p data-aos="fade-up" data-aos-delay="80">
            The team behind Yitalife; a service of Yita Medical Services (YMS)
          </p>
          <div className="page-breadcrumb">
            <Link to="/">Home</Link>
            <ion-icon
              name="chevron-forward-outline"
              style={{ fontSize: "13px" }}
            ></ion-icon>
            <Link to="/AboutUs">About</Link>
            <ion-icon
              name="chevron-forward-outline"
              style={{ fontSize: "13px" }}
            ></ion-icon>
            <span>Leadership</span>
          </div>
        </div>
      </div>

      {/* Intro */}
      <section className="leadership-intro">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="badge-yita" style={{ marginBottom: "18px" }}>
                <ion-icon name="people-outline"></ion-icon>
                Our Team
              </div>
              <h2>Trusted Professionals Building a Healthier Uganda</h2>
              <p>
                Yitalife is led by a dedicated team of medical professionals,
                public health experts, and community advocates who share a
                single mission: making quality healthcare accessible to every
                Ugandan.
              </p>
              <p>
                Our leadership team combines clinical excellence with
                operational expertise; ensuring that Yitalife consistently
                delivers safe, professional, and compassionate care to every
                patient we serve.
              </p>
              <div className="leadership-intro-btns">
                <Link to="/AboutUs">
                  <button className="leadership-btn-outline">
                    About Yitalife
                  </button>
                </Link>
                <Link to="/Appointment">
                  <button className="leadership-btn-primary">
                    Book Appointment
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
              <div className="leadership-hero-img-wrap">
                <img
                  src={joel1}
                  alt="Yitalife leadership team - Yita Medical Services Uganda"
                  className="leadership-hero-img"
                  onError={(e) => {
                    e.target.src = joel1;
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Cards */}
      <section className="leadership-team-section">
        <div className="container">
          <div
            className="text-center leadership-team-header"
            data-aos="fade-up"
          >
            <div className="badge-yita" style={{ margin: "0 auto 16px" }}>
              <ion-icon name="ribbon-outline"></ion-icon>
              Leadership &amp; Board
            </div>
            <h2 className="leadership-section-title">Meet Our Team</h2>
            <p className="leadership-section-sub">
              Our qualified doctors, nurses, and health professionals are
              dedicated to delivering the highest standard of care.
            </p>
          </div>

          <div className="row g-4">
            {leadership.map((person, i) => (
              <div
                className={`${person.tags ? "col-12" : "col-lg-6 col-md-12"}`}
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 70}
              >
                <article
                  className="leader-card"
                  aria-label={`${person.name} - ${person.role}`}
                >
                  {/* Avatar */}
                  <div
                    className="leader-avatar"
                    style={{ borderColor: person.accentColor }}
                  >
                    {person.img ? (
                      <img
                        src={person.img}
                        alt={`${person.name} - ${person.role} at Yitalife Uganda`}
                      />
                    ) : (
                      <AvatarPlaceholder
                        initials={person.initials}
                        color={person.accentColor}
                      />
                    )}
                  </div>

                  {/* Info */}
                  <div className="leader-info">
                    <h3 className="leader-name">{person.name}</h3>
                    <p
                      className="leader-role"
                      style={{ color: person.accentColor }}
                    >
                      {person.role}
                    </p>
                    <p className="leader-quals">
                      <ion-icon name="school-outline"></ion-icon>
                      {person.qualifications}
                    </p>

                    {/* Role tags - shown only when the person has them */}
                    {person.tags && (
                      <div className="leader-tags">
                        {person.tags.map((tag, ti) => (
                          <span key={ti} className="leader-tag">
                            {tag}
                          </span>
                        ))}
                      </div>
                    )}

                    <p className="leader-bio">{person.bio}</p>
                    {person.social?.twitter && (
                      <div className="leader-social">
                        <a
                          href={person.social.twitter}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={`${person.name} on Twitter`}
                        >
                          <ion-icon name="logo-twitter"></ion-icon>
                          Follow on Twitter
                        </a>
                      </div>
                    )}
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Strip */}
      <section className="leadership-trust-strip">
        <div className="container">
          <div className="row g-4 text-center">
            {[
              {
                icon: "shield-checkmark-outline",
                label: "Registered Enterprise",
                detail: "Reg No. 80020035497111",
              },
              {
                icon: "ribbon-outline",
                label: "Licensed Professionals",
                detail: "All staff are qualified and licensed",
              },
              {
                icon: "heart-outline",
                label: "Patient-Centred Care",
                detail: "Your wellbeing is our priority",
              },
              {
                icon: "globe-outline",
                label: "Est. 2019",
                detail: "Over 7 years serving Uganda",
              },
            ].map((item, i) => (
              <div
                className="col-lg-3 col-md-6"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 60}
              >
                <div className="trust-item">
                  <div className="trust-icon">
                    <ion-icon name={item.icon}></ion-icon>
                  </div>
                  <h5>{item.label}</h5>
                  <p>{item.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="leadership-cta">
        <div className="container text-center" data-aos="fade-up">
          <h2>Want to Join Our Team?</h2>
          <p>
            We are always looking for passionate medical professionals who share
            our mission of bringing healthcare closer to people.
          </p>
          <Link to="/Contact">
            <button className="leadership-cta-btn">Get in Touch</button>
          </Link>
        </div>
      </section>
    </div>
  );
}
